import { breakpoints, componentHeights, formattedBreakpoints } from 'ui/bend/themes/scales'

export {
  breakpoints,
  componentHeights,
  formattedBreakpoints
}
